export class AnalyticsUnitReq{
    unitId:number;
    
}